import React from "react";

import CashoutHistoryTableHeaderRow from "./CashoutHistoryTableHeaderRow";
import CashoutHistoryTableRows from "./CashoutHistoryTableRows";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default function CashoutHistoryBody() {
	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/CashoutHistoryBody.tsx"}
		>
			<div className="popup__body">
				<table className="table--primary">
					<thead className="table--primary__header table--primary__header--light">
						<CashoutHistoryTableHeaderRow />
					</thead>
					<tbody className="table--primary__body">
						<CashoutHistoryTableRows />
					</tbody>
				</table>
			</div>
		</ErrorBoundaryWithPropagation>
	);
}
